export default __webpack_public_path__ + "0a761e6dd2e7a781d97618c1fda221de.png";